
export default {
  name: 'BbLink',
  props: {
    to: String,
    label: String,
    iconLeft: String,
    iconRight: String,
    isExact: Boolean,
    exactClass: {
      type: String,
      default: 'exact',
    },
    activeClass: {
      type: String,
      default: 'is-active',
    },
    isDisabled: Boolean,
  },
  computed: {
    hasLeftIcon() {
      return this.iconLeft || this.$slots['icon-left'];
    },
    hasRightIcon() {
      return this.iconRight || this.$slots['icon-right'];
    },
  },
};
